"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_URI_BASE = exports.REDIRECT_URI = exports.MESSENGER_DELAY = exports.ISSUER_STORAGE_PARAMETER_FOR_GENESYS = exports.GENESYS_CONVERSATION_DISCONNECTED = exports.AUTH_IFRAME_ID = exports.AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS = void 0;
// istanbul ignore file @preserve -- No need to test constants.

/**
 * Iframe id for authentication.
 */
const AUTH_IFRAME_ID = exports.AUTH_IFRAME_ID = 'GenesysAuthFrame';

/**
 * Auth Code storage parameter.
 */
const AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS = exports.AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS = 'genesysAuthCode';

/**
 * Issuer storage parameter.
 */
const ISSUER_STORAGE_PARAMETER_FOR_GENESYS = exports.ISSUER_STORAGE_PARAMETER_FOR_GENESYS = 'genesysIssuer';

/**
 * Base URI for authentication.
 */
const REDIRECT_URI_BASE = exports.REDIRECT_URI_BASE = `https://clientapp-${process.env.NODE_ENV === 'production' ? '' : 'test-'}cdn.oriflame.com`;

/**
 * Redirect URI for authentication.
 */
const REDIRECT_URI = exports.REDIRECT_URI = `${REDIRECT_URI_BASE}/static/web-messenger/auth-callback/index.html`;
const MESSENGER_DELAY = exports.MESSENGER_DELAY = 2000;

/**
 * User action meta data dispatched when agent ends conversation.
 */
const GENESYS_CONVERSATION_DISCONNECTED = exports.GENESYS_CONVERSATION_DISCONNECTED = ['chat_conversation_end', 'genesys'];
